import React from 'react';
import s from '../RegistrationNewClient.module.css';

interface ErrorMessageProps {
	message?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({message}) => {
	if (!message) return null;
	
	return <span className={s.error}>{message}</span>;
};

export default ErrorMessage;

